var _g, _path, _path2, _g2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckServiceShieldIcon = function SvgCheckServiceShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 106,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#check-service-shield-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4EADF1",
    d: "m52.31 5.661 32.733 12.612 2.99 1.262.157 3.153c.472 7.882-.787 20.021-5.823 31.688-5.193 11.981-14.32 23.647-29.9 30.426l-1.889.788-2.046-.788c-15.58-6.779-24.707-18.445-29.9-30.426-5.036-11.667-6.295-23.806-5.823-31.688l.157-3.153 2.99-1.262L48.69 5.661l1.888-.788z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2399EE",
    d: "m52.235 5.661 32.802 12.612 2.996 1.262.157 3.153c.474 7.882-.788 20.021-5.834 31.688-5.204 11.981-14.351 23.647-29.964 30.426l-1.892.788c.005-33.83.002-36.204 0-80.717z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "check-service-shield-icon_svg__c",
    width: 77,
    height: 82,
    x: 12,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#check-service-shield-icon_svg__b)",
    d: "m52.31 5.661 32.734 12.612 2.99 1.262.157 3.153c.472 7.882-.787 20.021-5.823 31.688-5.193 11.981-14.32 23.647-29.9 30.426l-1.889.788-2.046-.788c-15.58-6.779-24.707-18.445-29.9-30.426-5.036-11.667-6.295-23.806-5.823-31.688l.157-3.153 2.99-1.262L48.691 5.661l1.888-.788z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#check-service-shield-icon_svg__c)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.177 3.029c.214.078.358.302.358.555v84.124c0 .323-.231.584-.517.584H8.128C3.106 88.292.14 81.98 3.076 77.4L50.599 3.242a.485.485 0 0 1 .578-.213m-.676 2.358L3.912 78.086c-2.419 3.774 0 9.038 4.217 9.038H50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.4 44.636 20.553 32.769c2.861 4.561-.014 10.887-4.958 10.887H50.018zm0 2.02L52.018 87.124h40.977c4.1 0 6.494-5.25 4.115-9.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4 46.23a.5.5 0 0 1-.421-.246L50.597 3.922a.65.65 0 0 1-.037-.606.51.51 0 0 1 .459-.316h41.976c4.945 0 7.82 6.325 4.959 10.887L77.822 45.984a.5.5 0 0 1-.421.246m0-1.594L97.11 13.21c2.38-3.793-.015-9.043-4.115-9.043H52.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.087 87.124 51.535 7.333v79.79zm1.2.406a.65.65 0 0 1-.075.522.5.5 0 0 1-.417.24H51.018a.49.49 0 0 1-.365-.171.63.63 0 0 1-.151-.413V3.584c0-.288.185-.533.437-.577s.494.125.572.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4 45.062c.168 0 .325.092.422.246l20.131 32.097c2.861 4.561-.014 10.887-4.958 10.887H51.018a.51.51 0 0 1-.459-.316.65.65 0 0 1 .038-.606l26.382-42.062a.5.5 0 0 1 .421-.246m0 1.594L52.018 87.124h40.977c4.1 0 6.494-5.25 4.115-9.043z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1081D3",
    d: "M70.25 37.343v-2.415L44.57 52.436 29.033 45.19v2.415L44.57 64.123z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#128BE3",
    fillRule: "evenodd",
    d: "m85.686 16.681 4.009 1.69.21 4.214v.009c.485 8.118-.807 20.525-5.96 32.463l-.001.002C78.615 67.352 69.21 79.39 53.152 86.378l-.011.005-2.537 1.058-2.723-1.049-.033-.014c-16.06-6.988-25.463-19.026-30.792-31.319v-.002c-5.154-11.938-6.446-24.345-5.962-32.463l.211-4.222 4.01-1.691L48.05 4.068 50.608 3l2.367 1.078zM52.31 5.661l-1.731-.788-1.889.789-32.733 12.612-2.99 1.261-.158 3.153c-.472 7.883.787 20.022 5.823 31.688 5.193 11.982 14.321 23.648 29.9 30.427l2.047.788 1.888-.788c15.58-6.78 24.708-18.445 29.901-30.427 5.036-11.666 6.295-23.805 5.823-31.688l-.158-3.153-2.99-1.261z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m70.25 35.007-5.39-5.232L44.57 50.067 34.423 39.921l-5.39 5.232L44.57 60.688z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check-service-shield-icon_svg__b",
    x1: 36.821,
    x2: 79.935,
    y1: 6.449,
    y2: 87.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "check-service-shield-icon_svg__a",
    width: 99.565,
    height: 104.717,
    x: 0.717,
    y: 0.873,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_799"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_158_799",
    result: "shape"
  })))));
};
export { SvgCheckServiceShieldIcon as ReactComponent };
export default "/images/check-service-shield-icon.svg";